/** @format */
import * as yup from "yup";



export const contactSchema = yup.object().shape({
  email: yup.string().required("email is required"),
  whatsapp: yup.string()
    .test(
      'message',
      'Number be 10 or 11 digits long',
      (val) => val?.length === 10 || val?.length === 11
    )
    .required("whatspp number is required"),

});
